/**
 * Created by jv on 15/05/2018.
 */
import CONSTANTS from "Sources/games/chicken-game/config/constants";

export default class Game extends Phaser.Scene
{
  constructor()
  {
    super({ key: "Game" });

    /**
     *  Keep the last high score registered.
     */
    this.bestTime = 0;
  }

  init()
  {
    // https://github.com/photonstorm/phaser/issues/3185
    this.scene.launch("Coop")
              .launch("Menu", { type: "pause-menu"})
              .launch("Scoreboard", { gameScene: this })
              .launch("GameOver", { gameScene: this });

    this.timePlaying = 0;

    this.gameOver = false;
    this.paused = false;
    this.debug = CONSTANTS.DEBUG;
  }

  create()
  {
    this.coop = this.scene.get("Coop");

    this.setSceneOrder();

    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    this.sand = this.add.image(0, 0, CONSTANTS.ATLAS_KEY, "scene/sand.jpg").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
    this.grass = this.add.image(0, 0, CONSTANTS.ATLAS_KEY, "scene/grass.png").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);

    this.coop.events.off("chick-escaped").on("chick-escaped", this.chickEscaped, this);

    this.gameTimer = this.time.addEvent({ delay: 1000, callback: this.increaseGameTime, callbackScope: this, loop: true });
  }

  setSceneOrder()
  {
    this.scene.moveAbove("Game", "Coop");
    this.scene.moveAbove("Coop", "Scoreboard");
    this.scene.moveAbove("Scoreboard", "Menu");
    this.scene.moveAbove("Menu", "GameOver");
  }

  update(time, delta)
  {
    this._updateDebugText();

    if(!this.gameOver && !this.paused)
    {
      this.updateLogic(time);
    }
  }

  updateLogic(time)
  {
    
  }

  endGame()
  {
    this.gameOver = true;
    
    //  Update the high score.
    this.bestTime = Math.max(this.timePlaying, this.bestTime);

    this.scene.get("Scoreboard").setHelpButtonInteractive(false);

    this.pause();

    this.time.delayedCall(1000, () =>
    {
      this.coop.clearCoop();
      this.events.emit("game-end");
    });
  }

  restart()
  {
    this.scene.stop("Coop")
              .stop("Scoreboard")
              .stop("Menu")
              .stop("GameOver")
              .start("Game");
  }

  resume()
  {
    this.paused = false;

    this.gameTimer.paused = false;
    this.scene.get("Coop").paused = false;
  }

  pause()
  {
    this.paused = true;

    this.gameTimer.paused = true;
    this.scene.get("Coop").paused = true;
  }

  togglePause()
  {
    if(this.paused)
    {
      this.resume();
    }
    else
    {
      this.pause();
    }
  }

  chickEscaped(chick)
  {
    this.endGame()
  }

  increaseGameTime()
  {
    this.events.emit("game-time-updated", ++this.timePlaying);
  }

  _updateDebugText()
  {
    if(this.debug)
    {
      var textContent = [];

      textContent.push("Time: " + this.timePlaying);
      textContent.push("Best time: " + this.bestTime);
      textContent.push("Game over: " + this.gameOver);
      textContent.push("Chicks in coop: " + this.coop.chicks.children.size);
      var timeTillNextChickSpawn = "/";
      if(this.coop.chickSpawnTimer !== null)
      {
        timeTillNextChickSpawn = Math.round(this.coop.chickSpawnTimer.delay / 1000) -  Math.round(this.coop.chickSpawnTimer.getElapsedSeconds());
      }
      textContent.push("Time until chick spawn: " + timeTillNextChickSpawn + "s");

      this.scene.get("Scoreboard")._debugText.setText(textContent);
    }
  }
}



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/scenes/game.js